/* eslint-disable ember/no-classic-components, ember/require-tagless-components */
import Component from '@ember/component';

export default class Alert extends Component {
  // 'warn' | (extend with 'info' | 'error' | 'success' as needed)
  variant = 'warn';

  title = null;
}
